// eslint-disable-next-line import/no-unresolved
import * as vuexOriginal from "vuexOriginal";

export const {
  Store,
  createLogger,
  createNamespacedHelpers,
  createStore,
  mapActions,
  mapGetters,
  mapMutations,
  mapState,
  storeKey,
  useStore
} = vuexOriginal;
